import { Order } from 'types/Order';
import { Maybe } from 'types/UtilityTypes';
import { useThrowableSWR } from 'utils/fetcher';

type OrderFetchResult = {
  order: Maybe<Order>;
  isLoading: boolean;
  error: Maybe<Error>;
};

export default function useFetchOrderByTrackingId(
  trackingId?: string
): OrderFetchResult {
  const { data, isLoading, error } = useThrowableSWR<Order>(
    trackingId ? `orders/tracking/${trackingId}` : null,
    false // Don't retry on 404s
  );

  return {
    order: data || null,
    isLoading,
    error,
  };
}
